import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { API, useAuth } from '../contexts/AuthContext';
import { formatDateBR } from '../helpers/formatDate';

// Mostra, uma vez por sessao do navegador, um modal com os chamados vencidos
// que interessam ao usuario: os atribuidos a ele + os sem atendente ("vazios").
// Montado uma unica vez (App), nao por rota, pra nao reabrir a cada navegacao.
const SESSION_KEY = 'alertaVencidosVisto';

function formatDataHora(valor) {
  if (!valor) return '';
  const d = new Date(valor);
  if (Number.isNaN(d.getTime())) return formatDateBR(valor);
  const hh = String(d.getHours()).padStart(2, '0');
  const mm = String(d.getMinutes()).padStart(2, '0');
  return `${formatDateBR(valor)} ${hh}:${mm}`;
}

export default function AlertaVencidos() {
  const { user, temPermissao } = useAuth();
  const navigate = useNavigate();
  const [vencidos, setVencidos] = useState([]);
  const [aberto, setAberto] = useState(false);

  const pode = !!user && temPermissao('ti:chamados');

  useEffect(() => {
    if (!pode) {
      setVencidos([]);
      setAberto(false);
      return undefined;
    }
    let cancelado = false;
    axios.get(`${API}/chamados/vencidos`)
      .then((res) => {
        if (cancelado) return;
        const lista = res.data?.data || [];
        setVencidos(lista);
        if (lista.length && sessionStorage.getItem(SESSION_KEY) !== 'sim') {
          setAberto(true);
        }
      })
      .catch(() => { /* alerta nunca bloqueia o portal */ });
    return () => { cancelado = true; };
  }, [pode]);

  const fechar = () => {
    sessionStorage.setItem(SESSION_KEY, 'sim');
    setAberto(false);
  };

  const irParaChamados = () => {
    fechar();
    navigate('/ti/chamados');
  };

  if (!aberto || !vencidos.length) return null;

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 1100,
        background: 'rgba(8, 23, 43, 0.6)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 16,
      }}
      onClick={(e) => { if (e.target === e.currentTarget) fechar(); }}
    >
      <div
        className="content-card"
        style={{
          width: 'min(560px, 96vw)', maxHeight: '85vh',
          display: 'flex', flexDirection: 'column', padding: 0, overflow: 'hidden',
        }}
      >
        <header style={{
          padding: '14px 18px',
          borderBottom: '1px solid var(--portal-border)',
          display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 12,
        }}>
          <strong style={{ color: '#dc3545' }}>
            <i className="bi bi-exclamation-triangle-fill me-2" />
            {vencidos.length === 1
              ? '1 chamado vencido'
              : `${vencidos.length} chamados vencidos`}
          </strong>
          <button
            type="button"
            className="btn btn-sm btn-outline-secondary"
            onClick={fechar}
            aria-label="Fechar"
          >
            <i className="bi bi-x-lg" />
          </button>
        </header>

        <div style={{ flex: 1, overflowY: 'auto', padding: '12px 18px' }}>
          <p style={{ fontSize: '0.82rem', color: 'var(--portal-muted)', marginBottom: 12 }}>
            Chamados com prazo de entrega vencido atribuidos a voce ou ainda sem atendente.
          </p>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {vencidos.map((c) => (
              <div
                key={c.id}
                style={{
                  padding: '10px 12px', borderRadius: 8,
                  border: '1px solid rgba(220, 53, 69, 0.35)',
                  background: 'rgba(220, 53, 69, 0.06)',
                  display: 'flex', flexDirection: 'column', gap: 2,
                }}
              >
                <div style={{ display: 'flex', justifyContent: 'space-between', gap: 8 }}>
                  <span style={{ fontWeight: 600, fontSize: '0.88rem' }}>
                    <span style={{ color: 'var(--portal-muted)', marginRight: 6 }}>#{c.id}</span>
                    {c.titulo}
                  </span>
                  <span style={{ color: '#dc3545', fontWeight: 600, fontSize: '0.8rem', whiteSpace: 'nowrap' }}>
                    <i className="bi bi-alarm me-1" />{formatDataHora(c.data_limite)}
                  </span>
                </div>
                <div style={{ fontSize: '0.76rem', color: 'var(--portal-muted)' }}>
                  {c.atendente
                    ? <><i className="bi bi-headset me-1" />{c.atendente}</>
                    : <em><i className="bi bi-person-dash me-1" />Sem atendente</em>}
                  {c.solicitante ? <span style={{ marginLeft: 10 }}><i className="bi bi-person me-1" />{c.solicitante}</span> : null}
                </div>
              </div>
            ))}
          </div>
        </div>

        <footer style={{
          padding: '12px 18px',
          borderTop: '1px solid var(--portal-border)',
          display: 'flex', justifyContent: 'flex-end', gap: 8,
        }}>
          <button type="button" className="btn btn-sm btn-outline-secondary" onClick={fechar}>
            Fechar
          </button>
          <button
            type="button"
            className="btn btn-sm"
            onClick={irParaChamados}
            style={{ background: '#2A8A9C', color: '#fff', border: 'none' }}
          >
            <i className="bi bi-list-check me-1" /> Ver chamados
          </button>
        </footer>
      </div>
    </div>
  );
}
